import notEmpty from '@/lib/helpers/not-empty';

export default notEmpty;
